import React, {
  AnimationEvent,
  FC,
  HTMLAttributes,
  PropsWithChildren,
} from "react";
import { useScreenContext } from "../../BigScreen";

type SquareListProps = PropsWithChildren<
  HTMLAttributes<HTMLDivElement> & {
    fullScreen?: boolean;
  }
>;

export const SquareList: FC<SquareListProps> = ({
  children,
  style,
  ...rest
}) => {
  const { onTemplateHidden } = useScreenContext();

  const handleAnimationEnd = (e: AnimationEvent<HTMLDivElement>) => {
    console.log(e.animationName);
    if (e.animationName === "disappear") {
      onTemplateHidden?.();
    }
  };

  return (
    <div
      className="square"
      onAnimationEnd={handleAnimationEnd}
      style={{ gridColumn: "1 / -1", gridRow: "1 / -1", ...style }}
      {...rest}
    >
      {children}
    </div>
  );
};
